(function ($, Drupal, once) {
  'use strict';

  const liParentClassName = 'menu-parenttitle';
  const menuLevelExpandedClass = 'menu-level-expanded';

  Drupal.behaviors.mobileMenu = {
    attach: function (context) {
      window.menuPartHideClass = window.menuPartHideClass || 'hidden-mm';
      window.mobileBreakpoint = window.mobileBreakpoint || 1024;

      if (!once('mobile-menu', 'html').length) {
        return;
      }

      let numResize = 0;
      let resize = '';

      // show hide mobile menu on screen resize
      $(window).on('resize.mobileMenu', function () {
        if (window.outerWidth >= window.mobileBreakpoint) {
          $('.hamburger--menu-container-icon__open').addClass('is-active');
          $('.hamburger--menu-container-icon__close').removeClass('is-active');
          $('.region-mobile-menu,.region-mobile-menu div.menu-dropdown-0 ul').addClass(window.menuPartHideClass);
          $('.region-mobile-menu div.menu-dropdown-0 ul').removeClass(menuLevelExpandedClass);
          $('.menu_link_content').attr('aria-hidden', 'true');
        }
        else {
          $('.region-mobile-menu').show();
        }

        if (numResize <= 1) {
          resize = setTimeout(function () {
            $(window).trigger('resize.mobileMenu');
            numResize++;
          }, 200);
        }
        else {
          clearTimeout(resize);
          numResize = 0;
        }
      });

      // mobile menu click functionality
      $(document).on('click', '.hamburger--menu-container-icon', function () {
        $('.hamburger--menu-container-icon').toggleClass('is-active');

        if ($('.hamburger--menu-container-icon__close').hasClass('is-active')) {
          $('.region-mobile-menu').removeClass(window.menuPartHideClass);
        }
        else {
          $('.region-mobile-menu,.region-mobile-menu div.menu-dropdown-0 ul.menu-level-1').addClass(window.menuPartHideClass);
          $('.region-mobile-menu div.menu-dropdown-0 ul').removeClass(menuLevelExpandedClass);
        }
      });

      // showing nav level 2
      $(document).on('click', '.region-mobile-menu ul.menu-level-0>li.menu-item--expanded>a', function (e) {
        e.preventDefault();
        let nextUl = $(this).parent('.menu-item--expanded').find('ul.menu-level-1');
        let menuContainer = $(this).parent('.menu-item--expanded').find('.menu_link_content');
        if (!nextUl.hasClass(menuLevelExpandedClass)) {
          menuContainer.attr('aria-hidden', 'false');
          menuContainer.removeClass(window.menuPartHideClass);
          nextUl.removeClass(window.menuPartHideClass);
          nextUl.addClass(menuLevelExpandedClass);
          nextUl.find(`li.${liParentClassName}`).first().remove();
          nextUl.prepend(`<li class='${liParentClassName}'><div class='parent-title-inner'><div class='icon-chevron-left mm-back'></div>${$(this)[0].outerHTML}</div></li>`);
        }
      });

      // hiding nav level 2
      $(document).on('click', `.region-mobile-menu ul.menu-level-1 li.${liParentClassName} div.mm-back`, function () {
        $(this).parents('ul.menu-level-1').addClass(window.menuPartHideClass);
        $(this).parents('.menu_link_content').attr('aria-hidden', 'true');
        setTimeout(() => {
          $(this).parents('ul.menu-level-1').removeClass(menuLevelExpandedClass);
        }, 250);
      });
    }
  };
})(jQuery, Drupal, once);
